import type { ISerialize } from '@/objects/ISerialize';

export class CopyStartTimesRequest implements ISerialize {
    public StartNumberIds: number[];

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { StartNumberIds?: number[] }) {
        this.StartNumberIds = values.StartNumberIds ?? [];
    }

    public serialize(): string {
        return '{' + `"StartNumberIds": [ ${this.StartNumberIds.map((x) => JSON.stringify(x))} ]` + '}';
    }

    /**
     * Creates an instance of CopyStartTimesRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { StartNumberIds?: number[] }): CopyStartTimesRequest {
        return new CopyStartTimesRequest(values);
    }

    public static _FromServerJson(json: any): CopyStartTimesRequest {
        return new CopyStartTimesRequest({ StartNumberIds: json.StartNumberIds });
    }

    /**
     * Creates an instance of CopyStartTimesRequest from another instance of CopyStartTimesRequest.
     * @param other The CopyStartTimesRequest you want to clone
     * @returns A cloned CopyStartTimesRequest
     */
    public static FromOther(other: CopyStartTimesRequest): CopyStartTimesRequest {
        return CopyStartTimesRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return CopyStartTimesRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'CopyStartTimesRequest';
}
